import React from 'react'
import { Container } from '../GodMode';
import Button from '../../Generic/Button';

const DOOR_TASKS = {
	"UNLOCK_DOOR": "UNLOCK_DOOR",
};

const DOOR_TASKS_CONFIG = {
	[DOOR_TASKS.UNLOCK_DOOR]: { 
		taskType: "unlock_door", 
		name: "Unlock Door" 
	},
};

const Door = ({ sendTask, loadingStates }) => {
	const isUnlockLoading = loadingStates[DOOR_TASKS_CONFIG[DOOR_TASKS.UNLOCK_DOOR].taskType] || false;

	const handleUnlockDoor = async () => {
		await sendTask(DOOR_TASKS_CONFIG[DOOR_TASKS.UNLOCK_DOOR], {});
	};

	return (
		<>
			<Container>
				<Button onClick={handleUnlockDoor} disabled={isUnlockLoading}>
					Unlock Door
				</Button>
			</Container>
		</>
	);
};

export default Door;
